export default __webpack_public_path__ + "static/media/progress.8548e284.png";